import { Box } from '@mui/material'
import { PageBackButton } from '~/common/page-back-button/page-back-button'
import { PageContents } from '~/common/page-contents/page-contents'
import { AccountProfileCard } from './account-profile-card'
import { AccountOverviewCard } from './account-overview-card'
import { AccountUpgradeCard } from './account-upgrade-card'
import { AccountLoginHistoryCard } from './account-login-history-card'
import { AccountDataExportCard } from './account-data-export-card'
import { AccountStorageCard } from './account-storage-card'

const contents = [
  { title: 'Profile', component: <AccountProfileCard /> },
  { title: 'Overview', component: <AccountOverviewCard /> },
  { title: 'Funds', component: <AccountUpgradeCard /> },
  // { title: 'Login History', component: <AccountLoginHistoryCard /> },
  { title: 'Data Export', component: <AccountDataExportCard />, requires: 'export_data' },
  { title: 'Storage', component: <AccountStorageCard /> },
]

export default function Account() {
  return (
    <Box sx={{ position: 'relative' }}>
      <PageBackButton />
      <PageContents pageTitle="Account" contents={contents} />
    </Box>
  )
}
